'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n  padding-top: 5px;\n'], ['\n  height: 100%;\n  padding-top: 5px;\n']);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _findResponderByIdFromList = require('conversations-schema/responders/operators/findResponderByIdFromList');

var _getAssignedAgentId = require('conversations-schema/operators/conversation/getAssignedAgentId');

var _InfiniteScroll = require('conversations-internal-components/util/InfiniteScroll');

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _ThreadListItem = require('./ThreadListItem');

var _ThreadListItem2 = _interopRequireDefault(_ThreadListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ThreadListInfiniteScroll = (0, _styledComponents2.default)(_InfiniteScroll2.default).withConfig({
  displayName: 'ThreadList__ThreadListInfiniteScroll'
})(_templateObject);

var ThreadList = _react2.default.createClass({
  displayName: 'ThreadedChatArea',

  propTypes: {
    agentRespondersList: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    onSelectThread: _react.PropTypes.func.isRequired,
    sendFromResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    threadList: _react.PropTypes.instanceOf(_immutable.List).isRequired
  },

  renderThreadList: function renderThreadList() {
    var _props = this.props,
        chatHeadingConfig = _props.chatHeadingConfig,
        coloring = _props.coloring,
        onSelectThread = _props.onSelectThread,
        threadList = _props.threadList,
        sendFromResponders = _props.sendFromResponders,
        agentRespondersList = _props.agentRespondersList;


    return threadList.map(function (thread) {
      var threadId = (0, _threadGetters.getThreadId)(thread);

      var assignedResponder = (0, _findResponderByIdFromList.findResponderByIdFromList)({
        responders: agentRespondersList,
        responderId: (0, _getAssignedAgentId.getAssignedAgentId)(thread)
      });

      return _react2.default.createElement(_ThreadListItem2.default, {
        key: 'thread.' + threadId,
        chatHeadingConfig: chatHeadingConfig,
        coloring: coloring,
        onClick: function onClick() {
          return onSelectThread(threadId);
        },
        sendFromResponders: sendFromResponders,
        thread: thread,
        assignedResponder: assignedResponder
      });
    });
  },
  render: function render() {
    return _react2.default.createElement(
      ThreadListInfiniteScroll,
      {
        className: 'thread-list',
        newestAtBottom: false,
        fetchMore: function fetchMore() {}
      },
      this.renderThreadList()
    );
  }
});

exports.default = ThreadList;
module.exports = exports['default'];